import {APP} from '../actions/types';

const INITIAL_STATE = {
  isRehydrationComplete: false,
  selectedParking: undefined,
  supportBottomSheet: undefined,
  location: undefined,
  permitionModal: false,
  landscapeView: false,
  hasPayment: false,
  birthDate: undefined,
  completeDepositeSheet: false,
  intervallFuncRef: undefined,
  isFirstTry: true,
  auxiliary: undefined,
  email: undefined,
  transactionsFilter : undefined ,
  moveToCoordinate : undefined , 
  selectedVehicle : undefined , 
};

const AppReducer = (
  state = INITIAL_STATE,
  action: {type: String; payload: any},
) => {
  switch (action.type) {
    case APP:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default AppReducer;
